const DISHES_AVAILABLE_HOTKEYS = {
  S: {
    hotkey: 's',
    description: 'Curation / QA / QC done the selected location',
  },
  SHIFT_S: {
    hotkey: 'shift+s',
    description: 'Curation / QA / QC done all locations from current page',
  },
  ENTER: {
    hotkey: 'enter',
    description: 'Start editing the selected cell',
  },
  ESC: {
    hotkey: 'esc',
    description: 'Stop/Save editing of the selected cell',
  },
  ALT_LEFT: {
    hotkey: 'alt+left',
    description:
      'Go to previous menu title (if a menu title is selected in the dish filters)',
  },
  OPTION_LEFT: {
    hotkey: 'option+left',
    description:
      'Go to previous menu title (if a menu title is selected in the dish filters)',
  },
  OPTION_RIGHT: {
    hotkey: 'option+right',
    description:
      'Go to next menu title (if a menu title is selected in the dish filters)',
  },
  ALT_RIGHT: {
    hotkey: 'alt+right',
    description:
      'Go to next menu title (if a menu title is selected in the dish filters)',
  },
  C: {
    hotkey: 'c',
    description: 'Remove misc and choice from text',
  },
  P: {
    hotkey: 'p',
    description: 'Open/Close ingredient drawer for selected dish',
  },
  SPACE: {
    hotkey: 'space',
    description: 'Accept/Reject ingredient drawer discrepency',
  },
  SHIFT_P: {
    hotkey: 'shift+p',
    description: 'Open/Close choice ingredient drawer for selected dish',
  },
  OPTION_P: {
    hotkey: 'option+p',
    description: 'Open/Close dish details drawer for selected dish',
  },
  ALT_P: {
    hotkey: 'alt+p',
    description: 'Open/Close dish details drawer for selected dish',
  },
  SHIFT_C: {
    hotkey: 'shift+c',
    description: 'Start/Confirm batch curation',
  },
  CMD_C: {
    hotkey: 'cmd+c',
    description: 'Copy to clipboard the link to the selected dish',
  },
  CTRL_C: {
    hotkey: 'ctrl+c',
    description: 'Copy to clipboard the link to the selected dish',
  },
  TAB: {
    hotkey: 'tab',
    description:
      'Cycle between ingredients select when an editable ingredient cell is in focus',
  },
  CMD_I: {
    hotkey: 'cmd+i',
    description: 'Mark text as choice text when a text field is in edit mode',
  },
  CMD_U: {
    hotkey: 'cmd+u',
    description: 'Mark text as misc text when a text field is in edit mode',
  },
  CTRL_I: {
    hotkey: 'ctrl+i',
    description: 'Mark text as choice text when a text field is in edit mode',
  },
  CTRL_U: {
    hotkey: 'ctrl+u',
    description: 'Mark text as misc text when a text field is in edit mode',
  },
}

export default DISHES_AVAILABLE_HOTKEYS
